module.exports = "<div class=\"col-xs-4\">\r\n    <h3>\r\n        Liste der Verlage\r\n    </h3>\r\n    <app-table-template *ngIf=\"publishers && columns\" [data]=\"publishers\" [columns]=\"columns\"></app-table-template><br>\r\n    <button class=\"btn btn-success\" *ngIf=\"userService.user && userService.user.userType === userService.Admin\" [routerLink]=\"['/publisher/new']\">\r\n            Neuen Verlag anlegen\r\n    </button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/publisherList/publisher.list.component.html
// module id = 268
// module chunks = 1